import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpContext } from '@angular/common/http';
import { 
  FORCE_INTERNAL, 
  SKIP_AUTH, 
  SKIP_TRACES, 
  SKIP_MULTILANGUAGE,
  CommonPhase 
} from '@argo/common';
import { 
  ScaButtonComponent,
  ScaBadgeComponent,
  ScaModuleTitleComponent,
  ScaAlertComponent,
  ScaIconComponent,
  ScaCardWorkshopComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-common-test-complete',
  standalone: true,
  imports: [
    CommonModule,
    ScaButtonComponent,
    ScaBadgeComponent,
    ScaModuleTitleComponent,
    ScaAlertComponent,
    ScaIconComponent,
    ScaCardWorkshopComponent
  ],
  templateUrl: './common-test.component.html',
  styleUrl: './common-test.component.scss'
})
export class CommonTestComponent {
  readonly phases = {
    IDLE: CommonPhase.IDLE,
    LOADING: CommonPhase.LOADING,
    LOADED: CommonPhase.LOADED,
    ERROR: CommonPhase.ERROR
  };

  readonly angularVersion = '16+';
  readonly coverage = 100;

  readonly testResult = computed(() => {
    // Placeholder for test results
    return null;
  });

  readonly tokenStats = computed(() => ({
    forceInternal: 3,
    skipAuth: 2,
    skipTraces: 1,
    skipMultilanguage: 1,
    total: 7
  }));

  testForceInternal(): void {
    const context = new HttpContext().set(FORCE_INTERNAL, true);
    console.log('✅ FORCE_INTERNAL token creado:', context);
    alert('✅ FORCE_INTERNAL: Token para forzar autenticación en APIs externas\n\nVer consola para detalles');
  }

  testSkipAuth(): void {
    const context = new HttpContext().set(SKIP_AUTH, true);
    console.log('✅ SKIP_AUTH token creado:', context);
    alert('✅ SKIP_AUTH: Token para omitir autenticación en APIs públicas\n\nVer consola para detalles');
  }

  testSkipTraces(): void {
    const context = new HttpContext().set(SKIP_TRACES, true);
    console.log('✅ SKIP_TRACES token creado:', context);
    alert('✅ SKIP_TRACES: Token para prevenir trace-of-trace loops\n\nVer consola para detalles');
  }

  testSkipMultilanguage(): void {
    const context = new HttpContext().set(SKIP_MULTILANGUAGE, true);
    console.log('✅ SKIP_MULTILANGUAGE token creado:', context);
    alert('✅ SKIP_MULTILANGUAGE: Token para omitir interceptor de traducción\n\nVer consola para detalles');
  }
}
